var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import MuiTablePagination from "@material-ui/core/TablePagination";
import { TablePaginationActions } from "./TablePaginationActions";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            marginTop: spacing(4),
        },
        toolbar: {
            "&&": {
                paddingLeft: 0,
                paddingRight: 0,
                minHeight: 0,
            },
        },
    });
}, { name: "EuiTablePagination" });
/**
 * @deprecated since version 2.5.0. Use TablePagination from epic-ui/table package.
 */
export var TablePagination = React.forwardRef(function TablePagination(props, ref) {
    var _a, _b;
    var classes = useStyles();
    return (React.createElement(MuiTablePagination, __assign({ rowsPerPageOptions: [], labelDisplayedRows: function () { return null; }, ActionsComponent: TablePaginationActions, component: "div" }, props, { classes: __assign(__assign({}, props.classes), { root: clsx(classes.root, (_a = props.classes) === null || _a === void 0 ? void 0 : _a.root), toolbar: clsx(classes.toolbar, (_b = props.classes) === null || _b === void 0 ? void 0 : _b.toolbar) }), ref: ref })));
});
//# sourceMappingURL=TablePagination.js.map